import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import ProgressTab from "../../components/admin/tabs/ProgressTab";
import AdminLayout from "../../components/admin/AdminLayout";
import useAdminData from "../../hooks/useAdminData";
import useAdminActions from "../../hooks/useAdminActions";

const AdminProgressPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleCoursesChange = () => {
    // Refresh data if needed
  };

  // Use custom hooks
  const adminData = useAdminData(user);

  const formatDate = (dateString) => {
    if (!dateString) return "Nunca";
    return new Date(dateString).toLocaleString("pt-BR");
  };
  const adminActions = useAdminActions(user, handleCoursesChange, () => {
    // Refresh all data
    adminData.fetchUsers();
    adminData.fetchGroups();
    adminData.fetchCertificates();
    adminData.fetchVideoAccess();
    adminData.fetchCourseProgress();
    adminData.fetchAdminCourses();
  });

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="Progresso dos Cursos">
      <ProgressTab
        courseProgressData={adminData.courseProgressData}
        courseProgressPagination={adminData.courseProgressPagination}
        availableCourses={adminData.availableCourses}
        loading={adminData.loading}
        error={adminData.error}
        onCourseFilterChange={adminData.setCourseFilter}
        onUserFilterChange={adminData.setUserFilter}
        onPageChange={adminData.setCourseProgressPage}
        onExportCSV={adminActions.exportCourseProgressCSV}
        progressFilters={adminData.progressFilters}
        onProgressFilterChange={(filter, value) => {
          adminData.setProgressFilters(prev => ({
            ...prev,
            [filter]: value
          }));
        }}
        onClearProgressFilters={() => {
          adminData.setProgressFilters({
            course_filter: "",
            user_filter: ""
          });
          adminData.fetchCourseProgress();
        }}
        onFetchCourseProgress={adminData.fetchCourseProgress}
        onExportCourseProgressCSV={adminActions.exportCourseProgressCSV}
        formatDate={formatDate}
      />
    </AdminLayout>
  );
};

export default AdminProgressPage;
